import axios from "axios";
import { auth } from "@/lib/firebase";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/leads`;

const headers = async () => {
  if (!auth.currentUser) throw new Error("Missing Firebase admin session");
  const token = await auth.currentUser.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

const authed = async (cfg = {}) => ({
  ...cfg,
  headers: { ...(cfg.headers || {}), ...(await headers()) },
});

export const formatLeadError = (err, fallback = "Lead request failed") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        const loc = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== "body").join(".") : "";
        const msg = item?.msg || item?.type;
        return loc && msg ? `${loc}: ${msg}` : msg;
      })
      .filter(Boolean);
    return messages.length ? messages.join("; ") : fallback;
  }
  return err?.message || fallback;
};

export const leadApi = {
  status: async () => (await axios.get(`${API}/status`, await authed())).data,
  jobs: {
    list: async (params = {}) => (await axios.get(`${API}/jobs`, await authed({ params }))).data,
    create: async (body) => (await axios.post(`${API}/jobs`, body, await authed())).data,
    update: async (id, patch) =>
      (await axios.patch(`${API}/jobs/${id}`, patch, await authed())).data,
    addSeeds: async (id, seedUrls) =>
      (await axios.post(`${API}/jobs/${id}/seeds`, { seed_urls: seedUrls }, await authed())).data,
    leads: async (id, params = {}) =>
      (await axios.get(`${API}/jobs/${id}/leads`, await authed({ params }))).data,
    contacts: async (id, params = {}) =>
      (await axios.get(`${API}/jobs/${id}/contacts`, await authed({ params }))).data,
    reviewContact: async (id, contactId, reviewStatus) =>
      (
        await axios.patch(
          `${API}/jobs/${id}/contacts/${contactId}`,
          { review_status: reviewStatus },
          await authed(),
        )
      ).data,
    enrichContacts: async (id) =>
      (await axios.post(`${API}/jobs/${id}/contacts/enrich`, {}, await authed())).data,
    exportCsv: async (id) =>
      (
        await axios.get(`${API}/jobs/${id}/export.csv`, await authed({ responseType: "blob" }))
      ).data,
    exportContactsCsv: async (id, reviewStatus = "") =>
      (
        await axios.get(
          `${API}/jobs/${id}/contacts/export.csv`,
          await authed({
            params: reviewStatus ? { review_status: reviewStatus } : {},
            responseType: "blob",
          }),
        )
      ).data,
  },
};
